var map = {
	"./Beer.png": "513d",
	"./Buffout.png": "8f82",
	"./CharismaBoost.png": "3fda",
	"./Cigarettes.png": "bcd9",
	"./Jet.png": "ff0b",
	"./Mentats.png": "a706",
	"./NukaCola.png": "09b1",
	"./Psycho.png": "cce9",
	"./RadX.png": "522a",
	"./ca.png": "a77d",
	"./shades.png": "68e9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b648";